import script from "./UserRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistration.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistration.vue?vue&type=style&index=0&id=4220c7b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4220c7b3"]])

export default __exports__